import makeStyles from '@mui/styles/makeStyles';
import {blue, blueGrey, orange} from "@mui/material/colors";

export const innerStyle = makeStyles((theme) => ({
	main: {
		/*padding: 20,*/
		minHeight: "100vh",
		maxWidth: "100vw",
		overflowX: "hidden",
		position: "absolute",
		paddingBottom: 20,
		"-webkit-scrollbar": {
			display: "none"
		},
		//backgroundColor: theme.palette.mode === "light" ? "rgba(255,255,255,0.68)" : "rgba(19,19,75,0.48)",
		//background: "linear-gradient(110deg, #e3f2fd 60%, #2962ff 40%)",
		//backgroundColor: "#b9bcdb",
		backgroundColor: theme.palette.background.default,
		//backgroundColor: theme.palette.mode === "light" ? blue[50] : indigo[900],
		//background: "linear-gradient(43deg, rgba(25,17,159,0.5) 0%, rgba(21,118,213,0.5) 41%, rgba(0,212,255,0.5) 100%)",
	},
	header: {
		display: "grid",
		gridTemplateRows: "74px 1fr",
		alignContent: "center",
		alignItems: "center"
	},
	logo: {
		width: 86,
		height: 87,
		padding: 4,
		margin: 10,
		marginRight: 8,
		alignSelf: "center",
		backgroundColor: "#FFF",
		//backgroundColor: indigo["A700"],
		//boxShadow: "rgb(131 189 255) 2px 2px 20px",
		"&>img": {
			width: "80%",
			height: "80%"
		}
	},
	paper: {
		padding: 20,
		borderRadius: 20,
		boxShadow: theme.shadows[1],
		[theme.breakpoints.down('lg')]: {
			padding: 10,
		}
		//background: "#a0a1a9",
		//color: "#242424",
		//backgroundColor: theme.palette.mode === "light" ? blue[100] : indigo[900]
		//backgroundColor: "rgba(255,255,255,0.9)",
		//color: "#cdecff"
	},
	paperLight: {
		padding: 20,
		borderRadius: 20,
		boxShadow: theme.shadows[1],
		[theme.breakpoints.down('lg')]: {
			padding: 10,
		}
		//background: "#a0a1a9",
		//color: "#242424",
		//backgroundColor: theme.palette.mode === "light" ? blue[100] : indigo[900]
		//backgroundColor: "rgba(255,255,255,0.9)",
		//color: "#cdecff"
	},
	flexStart: {
		display: "flex",
		alignItems: "flex-start",
		alignContent: "flex-start",
		flexWrap: "wrap",
		marginTop: 20,
		marginBottom: 10,
	},
	flexEnd: {
		display: "flex",
		alignItems: "flex-end",
		alignContent: "flex-end",
		justifyContent: "flex-end",
		width: "100%"
	},
	centerOnMd: {
		[theme.breakpoints.down('lg')]: {
			alignItems: "center",
			alignContent: "center",
			justifyContent: "center",
		}
	},
	card: {
		margin: 8,
		borderRadius: 20,
		"&:hover": {
			boxShadow: theme.shadows[18],
		}
	},
	cardActionArea: {
		padding: 8,
		height: "100%"
	},
	button: {
		textTransform: "capitalize",
		"&:hover": {
			boxShadow: theme.shadows[18],
			background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
			color: "#FFF",
		}
	},
	dayCell: {
		backgroundColor: theme.palette.mode === "light" ? blue[50] : blue[600],
		borderRadius: 20,
		color: theme.palette.mode === "light" ? blue[600] : blue[50],
		height: "100%",
		display: "flex",
		alignItems: "center",
		alignContent: "center",
		justifyContent: "center",
		position: "relative",
		//color: blue[900],
		width: 55,
		"&:hover": {
			width: 55,
			cursor: "pointer",
			backgroundColor: theme.palette.mode === "light" ? orange[100] : orange[600],
			color: theme.palette.mode === "light" ? orange[600] : orange[100],
			borderRadius: 20,
			height: "100%",
			display: "flex",
			alignItems: "center",
			alignContent: "center",
			justifyContent: "center"
		}
	},
	messageItem: {
		width: "100%",
		borderRadius: 20,
		padding: 14,
		marginBottom: 8,
		backgroundColor: theme.palette.mode === "light" ? blue[50] : blue[900],
		color: theme.palette.mode === "light" ? blue[900] : blue[50],
	},
	textFiled: {
		[`& .MuiFilledInput-multiline`]: {
			borderRadius: "20px 20px 0 0",
		},
	},
	profileAvatar: {
		width: 80,
		height: 80,
		margin: "auto"
	},
	noBorder: {
		border: "none",
	},
	timeLine: {
		display: "grid",
		gridTemplateColumns: "128px auto 1fr",
		[theme.breakpoints.down('lg')]: {
			gridTemplateColumns: "90px auto 1fr",
		}
	},
	timelinePaper: {
		[theme.breakpoints.down('lg')]: {
			paddingBottom: 30
		}
	},
	hideOnMd: {
		display: "contents",
		[theme.breakpoints.down('lg')]: {
			display: "none"
		}
	},
	gridColumToRow: {
		display: "grid",
		gridTemplateColumns: "98px 280px 1fr",
		height: 92,
		[theme.breakpoints.down('xl')]: {
			display: "grid",
			gridTemplateRows: "1fr 1fr 1fr",
			gridTemplateColumns: "auto",
			height: 270
		}
	},
	backButton: {
		color: theme.palette.text.primary,
		display: "inline-block"
	},
	underlineOnHover: {
		"&:hover": {
			textDecoration: "underline",
			cursor: "pointer"
		}
	},
	shadowOnHover: {
		boxShadow: "none",
		"&:hover": {
			cursor: "pointer",
			boxShadow: theme.shadows[18]
		}
	},
	chatProfilePaper: {
		position: "fixed",
		top: 50,
		right: 40,
		width: 300,
		height: 500,
		backgroundColor: theme.palette.mode === "light" ? blueGrey[50] : blueGrey[900],
		borderRadius: 22,
		zIndex: 3201,
		[theme.breakpoints.down('md')]: {
			top: 8,
			right: 8,
			width: "auto",
		}
	}
}))
